import firebase from "../../config/firebase";
import api from "../api/client";

require("firebase/auth");

const canhotoApi = {
  /**
   * Aprova exceção para canhoto batido fora do raio da entrega.
   * PATCH /v1/canhoto/:freightId/stopping-points/:pointId/excecao
   *
   * O token vai montado aqui, e não pelo interceptor: ele lê `localStorage.token`, que ninguém no
   * painel grava. Enquanto a etapa de autorização não arruma isso para todas as chamadas de uma vez,
   * o caminho que funciona é este — o mesmo do auth.api.js.
   */
  async aprovarExcecao({ freightId, pointId, justification }) {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) {
      throw new Error("Usuário não autenticado");
    }

    const idToken = await currentUser.getIdToken(true);

    return api.patch(
      `/v1/canhoto/${freightId}/stopping-points/${pointId}/excecao`,
      { justification },
      { headers: { Authorization: `Bearer ${idToken}` } },
    );
  },
};

export default canhotoApi;
